import {
  ShareableReference,
  ShareTargetType,
} from '@bindoc-projects/resource-domain-lib';

/** Display noun for a grantee type — "Nutzer" / "Gruppe" / "Firma". */
export function granteeTypeLabel(type: ShareTargetType): string {
  switch (type) {
    case 'user':
      return 'Nutzer';
    case 'group':
      return 'Gruppe';
    case 'company':
      return 'Firma';
    default:
      return 'Empfänger';
  }
}

function granteePhrase(type: ShareTargetType, name: string): string {
  switch (type) {
    case 'user':
      return `den Nutzer „${name}“`;
    case 'group':
      return `die Gruppe „${name}“`;
    case 'company':
      return `die Firma „${name}“`;
    default:
      return `„${name}“`;
  }
}

/**
 * Confirmation text for revoking one grant. Names the resource *and* the
 * recipient, and — for a group grantee — spells out that every member of
 * that group loses access, since "Freigabe entfernen" there has a much
 * larger blast radius than for a single user (BDA-5971).
 */
export function revokeGrantConfirmMessage(
  resourceName: string,
  grantee: ShareableReference,
): string {
  const granteeName = grantee.name?.trim() || grantee.id;
  const phrase = granteePhrase(grantee.type, granteeName);
  const groupHint =
    grantee.type === 'group'
      ? ' Alle Mitglieder dieser Gruppe verlieren dadurch den Zugriff.'
      : '';
  return (
    `Möchten Sie die Freigabe für "${resourceName}" wirklich entfernen? ` +
    `Der Inhalt selbst wird dabei nicht gelöscht – nur der Zugriff für ${phrase} wird entzogen.${groupHint}`
  );
}
